import Status, { StatusValue } from '../Data/Status';

type SetStatus = (status: StatusValue) => void;
type SetErrorDetails = (details: string) => void;

interface ServiceErrorLike {
  status?: StatusValue;
  errorDetails?: string;
}

const handleServiceError = (
  error: unknown,
  setStatus: SetStatus,
  setErrorDetails?: SetErrorDetails
) => {
  const errorObject = error && typeof error === 'object' ? (error as ServiceErrorLike) : undefined;

  // if the error is defined in the Status object, set status to this
  if (typeof error === 'number') {
    setStatus(error as StatusValue);
  } else if (errorObject?.status) {
    setStatus(errorObject.status);
  } else {
    setStatus(Status.UNKNOWN);
  }

  if (errorObject?.errorDetails) {
    setErrorDetails?.(errorObject.errorDetails);
  }
};

export const isResponseLimitReached = (error: unknown) =>
  !!error &&
  typeof error === 'object' &&
  (error as ServiceErrorLike).status === Status.RESPONSE_LIMIT_REACHED;

export default handleServiceError;
